export function getInitialVideoInput(current, config, compare = (a, b) => a < b) {
    var _a;
    let lowestCode;
    for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
        const code = videoInput.code;
        if (code === current)
            return current;
        if (lowestCode === undefined || compare(code, lowestCode)) {
            lowestCode = code;
        }
    }
    return lowestCode !== null && lowestCode !== void 0 ? lowestCode : current;
}
export function isHttpRequestAsyncHandler(handler) {
    return typeof handler.path === 'string';
}
export function isHttpRequestEmulatorConstructor(emulator) {
    return emulator.emulatorType === 'httpRequestEmulator';
}
export function isHttpRequestRegExpAsyncHandler(handler) {
    return handler.path instanceof RegExp;
}
export function isSocketEmulatorConstructor(emulator) {
    return emulator.emulatorType === 'socketEmulator';
}
export function isUdpEmulatorConstructor(emulator) {
    return emulator.emulatorType === 'udpEmulator';
}
